import { createContext, useContext, useState } from "react";

const defaultLanguage = "uk";

export const LangContext = createContext({
  language: defaultLanguage,
  setLanguage: () => {},
});


export const useLang = () => useContext(LangContext);

export const LangProvider = ({ children }) => {
  const [language, setLanguage] = useState(defaultLanguage);

  const value = {
    language,
    setLanguage,
  };

  return (
    <LangContext.Provider value={value}>
      {children}
    </LangContext.Provider>
  );
};
